@use "@fukuri-admins/ui/layout" as *;

.title {
  margin: 0;
  color: text("High");
  @include typography("Jp/16_W6");
}
